<!-- Profile Header Component -->
<ms-member-profile-header [(member)]="member" [isLoading]="isLoading()"
  [navItems]="filteredNavItems()" (tabChanged)="onTabChanged($event)" (memberUpdated)="onMemberUpdated()"
  (sendInviteRequested)="onSendInviteRequested()"
  (editProfileRequested)="onEditProfileRequested()"></ms-member-profile-header>

<!-- No [organization]: the modal only reads it on its Create path (title text and the createMember
     payload) and this page always opens it to edit. Passing the active organization here named an
     organization unrelated to the member whenever the two diverged (DEV-2643). -->
<ms-member-form-modal
  [member]="member()"
  [formState]="editFormState()"
  (onSuccessConfirm)="onEditSuccess()" />

<!-- Tab Content Cards -->
<div class="tab-content mx-0 mx-sm-4 border-0" id="profileTabsContent">
  @if (member()) {
  @for (item of filteredNavItems(); track item.id; let i = $index) {
    @if (item.active) {
      <div class="tab-pane fade show active" [id]="item.id" role="tabpanel"
        [attr.aria-labelledby]="item.id + '-tab'" tabindex="0">

        <!-- Content slot for each tab -->
        @switch (item.id) {
          <!-- Properties Content -->
          @case ('properties') {
            <ms-member-properties [member]="member()"></ms-member-properties>
          }

          <!-- Invoicing Content -->
          @case ('invoicing') {
            <ms-member-invoicing [member]="member()"></ms-member-invoicing>
          }

          <!-- Payment History Content -->
          @case ('payment-history') {
            <ms-member-payment-history [member]="member()" [isEntityOwner]="isEntityOwner()"></ms-member-payment-history>
          }

          @case ('communication-history') {
            <ms-member-communication-history [member]="member()"></ms-member-communication-history>
          }

          @case ('logs') {
            <ms-member-logs [member]="member()"></ms-member-logs>
          }

          <!-- Directory visibility. The tab is ownerOnly, so this only ever renders for the member themselves. -->
          @case ('settings') {
            <ms-member-settings [member]="member()"
              (memberUpdated)="onMemberSettingsUpdated($event)"></ms-member-settings>
          }

          <!-- Default Content for other tabs -->
          @default {
            <div class="card">
              <div class="card-body">
                <p>Content for {{item.label}} will be implemented here.</p>
              </div>
            </div>
          }
        }
      </div>
    }
  }
  }
</div>

<ms-confirmation-modal 
  #memberProfileConfirmationModalRef
  modalId="memberProfileConfirmationModal"
  [(isSubmitting)]="isSubmitting"
  (confirmed)="onConfirmationModalConfirmed()"
  (cancelled)="onConfirmationModalCanceled()">
</ms-confirmation-modal>

<ms-info-modal 
  #memberProfileInfoModalRef
  modalId="memberProfileInfoModal"
  title="Send Invitation"
  (onConfirm)="onInfoModalConfirmed()">
</ms-info-modal>
